import clsx from 'clsx';
import { ModalTrans2 } from 'ctls/modal/ModalTrans2';
import { i18ntrans } from 'language/i18nkey';
import { langutil } from 'language/langutil';
import { IfLoginInfo } from 'models/IfLoginInfo';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import svcs from 'services';
import { fontFamilyMedium } from 'style/fonts';
import styled from 'styled-components';

interface Props {
  loginInfo?: IfLoginInfo;
  clickBookMark?: boolean;
  checkToastPopup?: boolean;
  type: string;
  seq?: any;
  msg?: string;
}

function ToastPopup(props: Props) {
  const [visible, setVisible] = useState(false);
  const timerIdRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const prevSeqRef = useRef(props.seq);

  useEffect(() => {
    if (prevSeqRef.current !== props.seq) {
      setVisible(true);
      if (timerIdRef.current) clearTimeout(timerIdRef.current);
      timerIdRef.current = setTimeout(() => {
        setVisible(false);
        timerIdRef.current = null;
      }, 3000);
    }
    prevSeqRef.current = props.seq;
  }, [props.seq]);

  useEffect(() => {
    return () => {
      if (timerIdRef.current) {
        clearTimeout(timerIdRef.current);
      }
    };
  }, []);

  const getTranslation = (key: string): string => {
    return i18ntrans.prod(key as any) || '';
  };

  const renderBookMarkToast = (clear: boolean) => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    const { country, lang } = langutil.splitLangCode(svcs.svcLang.lang());
    return (
      <div>
        {clear ? (
          <div className={clsx('toast-wrap bookmark-toast', scrollY !== scrollEnd ? '' : '')}>
            <div className={'toast-text'}>{getTranslation('I18N_PRODUCT_DOC_BOOKMARK')}</div>
            <Link
              to={{
                pathname: `/${country}/${lang}/myPage`,
                search: 'menu=bookmark',
              }}
              state={{ id: props.loginInfo?.userId }}>
              {getTranslation('I18N_PRODUCT_MYPAGE')}
            </Link>
          </div>
        ) : (
          <div className={clsx('toast-wrap bookmark-toast', scrollY !== scrollEnd ? '' : '')}>
            <div className={'toast-text'}>{getTranslation('I18N_PRODUCT_DOC_BOOKMARK_FAILED')}</div>
            <Link
              to={{
                pathname: `/${country}/${lang}/myPage`,
                search: 'menu=bookmark',
              }}
              state={{ id: props.loginInfo?.userId }}>
              {getTranslation('I18N_PRODUCT_MYPAGE')}
            </Link>
          </div>
        )}
      </div>
    );
  };

  const renderShareToast = () => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        <div className={clsx('toast-wrap share-toast', scrollY !== scrollEnd ? '' : '')}>
          <div className={'toast-text'}>{getTranslation('I18N_URL_COPIED')}</div>
        </div>
      </div>
    );
  };

  const renderSelectorShare = () => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
          <div className={'toast-text'}>{getTranslation('I18N_PRODUCT_SELECTOR_SHARE')}</div>
        </div>
      </div>
    );
  };

  const renderSelectorCompareTab = () => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
          <div className={'toast-text'}>{getTranslation('I18N_PRODCUT_SELECTOR_COMPARE_TAB')}</div>
        </div>
      </div>
    );
  };

  const renderSelectorCompareTabHmi = () => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
          <div className={'toast-text'}>{getTranslation('I18N_PRODCUT_SELECTOR_COMPARE_TAB_HMI')}</div>
        </div>
      </div>
    );
  };

  const renderSelectorCompareTabVfd = () => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
          <div className={'toast-text'}>{getTranslation('I18N_PRODCUT_SELECTOR_COMPARE_TAB_VFD')}</div>
        </div>
      </div>
    );
  };

  const renderSelectorAddedTab = () => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
          <div className={'toast-text'}>{getTranslation('I18N_PRODCUT_SELECTOR_ADDED_TAB')}</div>
        </div>
      </div>
    );
  };

  const renderUnknown = () => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
          <div className={'toast-text'}>{getTranslation('I18N_PRODCUT_UNKNOWN_USER')}</div>
        </div>
      </div>
    );
  };

  const renderMsg = () => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
          <div className={'toast-text'}>{props.msg}</div>
        </div>
      </div>
    );
  };

  const renderSelectorReset = () => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
          <div className={'toast-text'}>{getTranslation('I18N_PRODUCT_SELECTOR_RESET')}</div>
        </div>
      </div>
    );
  };

  const renderSelectorAdd = (clear: boolean) => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        {clear ? (
          <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
            <div className={'toast-text'}>{getTranslation('I18N_PRODUCT_SELECTOR_ADD')}</div>
          </div>
        ) : (
          <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
            <div className={'toast-text'}>{getTranslation('I18N_PRODUCT_SELECTOR_ADD_CLEAR')}</div>
          </div>
        )}
      </div>
    );
  };

  const renderSelectorAddOption = () => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
          <div className={'toast-text'}>{getTranslation('I18N_PRODUCT_SELECTOR_ADD')}</div>
        </div>
      </div>
    );
  };

  const renderSelectorCompare = (clear: boolean) => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        {clear ? (
          <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
            <div className={'toast-text'}>{getTranslation('I18N_PRODUCT_SELECTOR_COMPARE')}</div>
          </div>
        ) : (
          <div className={clsx('toast-wrap selectorAdd', scrollY !== scrollEnd ? '' : '')}>
            <div className={'toast-text'}>{getTranslation('I18N_PRODUCT_SELECTOR_COMPARE_CLEAR')}</div>
          </div>
        )}
      </div>
    );
  };

  const renderFeedbackToast = () => {
    const scrollY = window.scrollY;
    const scrollEnd = document.body.scrollHeight - window.innerHeight;

    return (
      <div>
        <div className={clsx('toast-wrap feedback-toast', scrollY !== scrollEnd ? '' : '')}>
          <div className={'toast-text'}>{getTranslation('I18N_FEEDBACK_ALERT')}</div>
        </div>
      </div>
    );
  };

  const renderToast = (type: string) => {
    switch (type) {
      case 'feedback':
        return renderFeedbackToast();

      case 'bookmark':
        return renderBookMarkToast(false);

      case 'bookmark-clear':
        return renderBookMarkToast(true);

      case 'share':
        return renderShareToast();

      case 'selectorAdd':
        return renderSelectorAdd(true);

      case 'selectorAdd-clear':
        return renderSelectorAdd(false);

      case 'selectorCompare':
        return renderSelectorCompare(true);

      case 'selectorCompare-clear':
        return renderSelectorCompare(false);

      case 'selectorShare':
        return renderSelectorShare();
      case 'selectorAddOption':
        return renderSelectorAddOption();

      case 'selectorCompareTab':
        return renderSelectorCompareTab();
      case 'selectorCompareTabHmi':
        return renderSelectorCompareTabHmi();
      case 'selectorCompareTabVfd':
        return renderSelectorCompareTabVfd();
      case 'selectorAddedTab':
        return renderSelectorAddedTab();
      case 'selectorReset':
        return renderSelectorReset();
      case 'unknown':
        return renderUnknown();
      case 'msg':
        return renderMsg();
    }
  };

  const handleClick = () => {
    setVisible(false);
    if (timerIdRef.current) {
      clearTimeout(timerIdRef.current);
      timerIdRef.current = null;
    }
  };

  return (
    <>
      {visible && (
        <ModalTrans2>
          <Toast onClick={handleClick}>{renderToast(props.type)}</Toast>
        </ModalTrans2>
      )}
    </>
  );
}

export default ToastPopup;

const Toast = styled.div`
  .toast-wrap {
    position: fixed;
    left: calc(50% + 60.8rem);
    bottom: 3rem;
    min-width: 320px;
    width: max-content;
    height: 6rem;
    //z-index: 10002;
    z-index: 2147483001;
    background: #2a2c2f;
    border-radius: 4px;
    line-height: 6rem;
    padding: 0 2.4rem;
    display: flex;
    justify-content: space-between;

    &.on {
      bottom: calc(25%);
    }

    .toast-text {
      color: white;
      ${fontFamilyMedium};
      font-size: 1.4rem;
    }

    a {
      color: #407dd8;
      ${fontFamilyMedium};
      font-size: 1.4rem;
    }
  }

  .bookmark-toast {
    &.no0 {
      bottom: 3rem;
    }

    &.no1 {
      bottom: 15rem;
    }

    &.no2 {
      bottom: 25rem;
    }
  }

  @media screen and (min-width: 765px) {
    .toast-wrap {
      left: inherit;
      right: 2rem;
    }
  }
  @media screen and (max-width: 764px) {
    .toast-wrap {
      left: 0;
      right: 0;
      margin: auto;
    }
  }
`;
